/**
 * Wave 8 — Resolve AI Pursuit Brief target from ECLE lineage.
 * Reuses Approval Brief builders — no parallel brief engine.
 */

export type PursuitBriefTarget = {
  entityType: string;
  entityId: string;
  label: string;
};

/** Preference: approval-backed commercial entities (newest lineage wins). */
const BRIEF_ENTITY_PRIORITY: Array<{ type: string; label: string; aliases?: string[] }> = [
  { type: 'epc_project_mobilization', label: 'Mobilization', aliases: ['epc_mobilization'] },
  { type: 'epc_award_acceptance', label: 'Award acceptance', aliases: ['epc_award'] },
  { type: 'epc_tender_submission', label: 'Tender submission' },
  { type: 'epc_bid_decision', label: 'Bid decision' },
];

export function resolvePursuitBriefTarget(
  lineage: Array<{ entityType: string; entityId: string; stageKey?: string }>
): PursuitBriefTarget | null {
  if (!lineage?.length) return null;

  for (const pref of BRIEF_ENTITY_PRIORITY) {
    const aliases = [pref.type, ...(pref.aliases || [])];
    // Prefer last matching node (later stage)
    for (let i = lineage.length - 1; i >= 0; i -= 1) {
      const n = lineage[i];
      if (aliases.includes(String(n.entityType || ''))) {
        const entityId = String(n.entityId || '').trim();
        if (!entityId) continue;
        return {
          entityType: pref.type,
          entityId,
          label: pref.label,
        };
      }
    }
  }
  return null;
}
